if (!customElements.get('tmg-variant-thumbs')) {
  // The theme re-renders the whole variant picker after every selection, so remember
  // each row's scroll position and restore it on the fresh copy.
  const scrollMemory = new Map();

  customElements.define(
    'tmg-variant-thumbs',
    class TmgVariantThumbs extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.tmg-variant-thumbs__track');
        this.prev = this.querySelector('.tmg-variant-thumbs__nav--prev');
        this.next = this.querySelector('.tmg-variant-thumbs__nav--next');
        if (!this.track) return;

        this.update = this.update.bind(this);
        this.onScroll = this.onScroll.bind(this);

        this.track.style.scrollBehavior = 'auto';
        const saved = scrollMemory.get(this.dataset.key);
        if (saved != null) this.track.scrollLeft = saved;
        this.revealChecked();
        this.track.style.scrollBehavior = '';

        this.prev.addEventListener('click', () => this.scrollByPage(-1));
        this.next.addEventListener('click', () => this.scrollByPage(1));
        this.track.addEventListener('scroll', this.onScroll, { passive: true });
        this.resizeObserver = new ResizeObserver(this.update);
        this.resizeObserver.observe(this.track);
        window.addEventListener('resize', this.update);
        this.update();
      }

      disconnectedCallback() {
        this.track?.removeEventListener('scroll', this.onScroll);
        this.resizeObserver?.disconnect();
        window.removeEventListener('resize', this.update);
      }

      scrollByPage(direction) {
        this.track.scrollBy({ left: direction * this.track.clientWidth * 0.8, behavior: 'smooth' });
      }

      revealChecked() {
        const label = this.track.querySelector('input:checked + label');
        if (!label) return;
        const left = label.offsetLeft;
        const right = left + label.offsetWidth;
        if (left < this.track.scrollLeft) this.track.scrollLeft = left;
        else if (right > this.track.scrollLeft + this.track.clientWidth) this.track.scrollLeft = right - this.track.clientWidth;
      }

      onScroll() {
        // Only the visible copy records its position (the old copy lingers hidden briefly).
        if (this.offsetParent) scrollMemory.set(this.dataset.key, this.track.scrollLeft);
        this.update();
      }

      update() {
        const max = this.track.scrollWidth - this.track.clientWidth;
        this.prev.hidden = this.track.scrollLeft <= 1;
        this.next.hidden = max <= 1 || this.track.scrollLeft >= max - 1;
      }
    }
  );
}
